import { Outlet, Navigate } from "react-router-dom";
import Cookies from "js-cookie";

function ProtectedRouteBackoffice() {
  const tokenCookie = Cookies.get("token");

  if (!tokenCookie) {
    return <Navigate to="/acesso-negado" replace />;
  }

  try {
    const token = JSON.parse(tokenCookie);

    const payloadBase64 = token.jwt.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(payloadBase64));
    const grupo = Number(payload.GrupoDeUsuarioId);

    if (grupo !== 1) {
      Cookies.remove("token");
      return <Navigate to="/acesso-negado" replace />;
    }

    return <Outlet />;
  } catch (error) {
    console.error("Erro ao validar rota do backoffice:", error);
    Cookies.remove("token");
    return <Navigate to="/acesso-negado" replace />;
  }
}

export default ProtectedRouteBackoffice;
